import React from 'react';
import { Link } from 'react-router-dom';
import { SectionHeading } from '../ui/SectionHeading';
import { motion } from 'framer-motion';
import { PipelineLines } from '../graphics/PipelineLines';
import { ArrowRightIcon } from 'lucide-react';
import { useLang } from '../../lib/i18n/LanguageContext';
import { dictionary } from '../../lib/i18n/dictionary';
export function Founder() {
  const {
    lang
  } = useLang();
  const t = dictionary.founder;
  return <section id="founder" className="relative py-24 md:py-32 bg-navy-deep overflow-hidden" data-id="element-365">
      <div className="absolute inset-0 tech-grid opacity-50" aria-hidden="true" data-id="element-366" />
      <PipelineLines className="absolute top-0 inset-x-0 h-20 text-gold/30" data-id="element-367" />

      <div className="relative max-w-4xl mx-auto px-5 md:px-8 text-center" data-id="element-368">
        <SectionHeading variant="dark" align="center" eyebrow={t.eyebrow[lang]} title={t.title[lang]} data-id="element-369" />
        <motion.p initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="mt-7 text-slate-300 text-base md:text-lg leading-relaxed" data-id="element-370">
          {t.body[lang]}
        </motion.p>

        <Link to="/about" className="mt-8 inline-flex items-center gap-2 px-5 py-3 border border-white/15 hover:border-gold/50 rounded-sm text-slate-200 hover:text-white text-sm transition-colors" data-id="element-371">
          {t.moreAbout[lang]}
          <ArrowRightIcon className="w-3.5 h-3.5" data-id="element-372" />
        </Link>

        <div className="mt-8 inline-flex items-center gap-3 px-5 py-3 border border-white/10 rounded-sm" data-id="element-373">
          <span className="w-1.5 h-1.5 bg-gold rounded-full" data-id="element-374" />
          <span className="font-mono text-[11px] tracking-[0.25em] uppercase text-slate-300" data-id="element-375">
            {t.corridor[lang]}
          </span>
        </div>
      </div>
    </section>;
}